export default __webpack_public_path__ + "static/media/musicCasetteTape.6b2c1ec5.jpg";